<script setup>
import { computed, ref } from 'vue';
import { I18nT } from 'vue-i18n';
import CloudWhatsapp from './CloudWhatsapp.vue';
import WhatsappEmbeddedSignup from './WhatsappEmbeddedSignup.vue';

const manualSetup = ref(false);
const embeddedSignupConfigured = computed(
  () =>
    Boolean(window.chatwootConfig?.whatsappAppId) &&
    window.chatwootConfig.whatsappAppId !== 'none' &&
    Boolean(window.chatwootConfig?.whatsappConfigurationId)
);

const showEmbeddedSignup = computed(
  () => embeddedSignupConfigured.value && !manualSetup.value
);
</script>

<template>
  <div class="overflow-auto col-span-6 p-6 w-full h-full">
    <div class="px-6 py-5 rounded-2xl border border-n-weak">
      <WhatsappEmbeddedSignup
        v-if="showEmbeddedSignup"
        enable-calling-on-complete
      />
      <CloudWhatsapp v-else enable-calling-on-complete />

      <div v-if="showEmbeddedSignup" class="pt-6 mt-6 border-t border-n-weak">
        <I18nT
          keypath="INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.MANUAL_FALLBACK"
          tag="p"
          class="text-sm text-n-slate-11"
        >
          <template #link>
            <a
              href="#"
              class="underline text-n-brand"
              @click.prevent="manualSetup = true"
            >
              {{
                $t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.MANUAL_LINK_TEXT')
              }}
            </a>
          </template>
        </I18nT>
      </div>
    </div>
  </div>
</template>
